import React from 'react';

import CartList from './CartList';

const CartContainer = () => {

    return(
        <h1>
            CartContainer
            <CartList />
        </h1>
    )
}

export default CartContainer;